import { Box } from "@mui/material";
import { FC, useState } from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import ImgBg from "../../assets/images/products/thematic-data/bg-data-card.png";

interface Props {
  image: any;
  title: string;
  text: string;
  reverseTexts: string[];
}

const ThematicDataCarouselCard: FC<Props> = ({
  image,
  title,
  text,
  reverseTexts,
}) => {
  const [flipped, setFlipped] = useState<boolean>(false);

  const toggleFlipped = () => setFlipped(!flipped);

  return (
    <Box
      sx={{
        position: "relative",
        margin: "0 14px",
        paddingBottom: "8rem",
        borderRadius: "1rem",
        overflow: "hidden",
      }}
    >
      <Box sx={{ zIndex: -1 }}>
        <img src={image} alt={title} />
      </Box>

      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: flipped ? "auto" : "17rem",
          minHeight: "12rem",
          bottom: 0,
          display: "flex",
          flexDirection: "column",
          background: `url(${ImgBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          padding: "1.5rem 1.5rem 0.5rem",
          zIndex: 1,
          transition: "padding 1s, margin 5s, height 1s",
        }}
      >
        {!flipped && (
          <Box
            sx={{
              fontSize: 25,
              lineHeight: 1.2,
              fontWeight: 600,
              paddingBottom: "0.75rem",
              maxWidth: "60%",
            }}
          >
            {title}
          </Box>
        )}
        {flipped ? (
          <Box
            sx={{
              flex: 1,
              fontSize: 15,
              fontWeight: 500,
              paddingTop: "0.5rem",
              paddingLeft: "1rem",
              paddingBottom: "1rem",
            }}
          >
            <ul style={{ listStyle: "disc" }}>
              {reverseTexts.map((str, idx) => (
                <li key={str + idx}>{str}</li>
              ))}
            </ul>
          </Box>
        ) : (
          <Box sx={{ flex: 1, fontSize: 15, fontWeight: 500 }}>{text}</Box>
        )}
        <Box
          sx={{
            width: "max-content",
            display: "inline-flex",
            alignItems: "center",
            cursor: "pointer",
            border: "1px solid",
            borderColor: flipped ? "#fff" : "transparent",
            padding: flipped ? "0.5rem" : "0.5rem 0",
            marginBottom: 0,
          }}
          onClick={toggleFlipped}
        >
          {flipped ? (
            <>
              <Box sx={{ fontWeight: 600 }}>Return</Box>
              <Box
                sx={{
                  width: 20,
                  height: 20,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: "0.5rem",
                }}
              >
                <KeyboardArrowLeftIcon htmlColor="#fff" />
              </Box>
            </>
          ) : (
            <>
              <Box sx={{ fontWeight: 600 }}>Themes</Box>
              <Box
                sx={{
                  width: 20,
                  height: 20,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#fff",
                  marginLeft: "0.5rem",
                }}
              >
                <KeyboardArrowRightIcon htmlColor="#792785" />
              </Box>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ThematicDataCarouselCard;
